export const lcpOptions = [
	'(aq) Networks Limited',
	'08Direct Limited',
	'24 SEVEN CLOUD COMMUNICATIONS LTD',
	'24 Seven Communications Limited',
	'447 Services Ltd',
	'4D INTERACTIVE LTD',
	'4Net Technologies Limited',
	'5 Rings Telecom Limited',
	'5G Communications Limited',
	'8x8 UK Limited',
	'9EONS LIMITED',
	'A2B Telecom Limited',
	'Abbey Telecom Limited',
	'Ace Call Ltd',
	'Active Business Communications Limited',
	'Active Voice & Data Ltd',
	'Adepteo Limited',
	'Admiral Telecom Limited',
	'Adviqo UK Limited',
	'AllPoints Fibre Networks Limited',
	'Alnitak GmbH',
	'Aloha Telecommunications Ltd',
	'Alphatalk Limited',
	'alwaysON Ltd',
	'AMSUK LTD',
	'Andrews & Arnold Ltd',
	'Angmar Universal SA',
	'Antheus Telecom Limited',
	'Anywhere Sim Limited',
	'AOL Europe Services SARL',
	'AOL UK Ltd',
	'API Telecom Limited',
	'AQL (NUMBERING) Ltd',
	'AQL Wholesale Ltd',
	'Aspire Technology Solutions Ltd',
	'Assume Nothing Limited',
	'Atlas Communications NI Limited',
	'Atlas Interactive Group Limited',
	'Atmoso Limited',
	'Atomstream Limited',
	'Audio Visual Machines Limited',
	'AVC One Limited',
	'Axione UK Limited',
	'Babble Cloud (SUI) Limited',
	'Barritec Limited',
	'Barritel Limited',
	'Be Un Limited',
	'Beaming Limited',
	'Belgacom International Carrier Services SA',
	'Bellingham Telecommunications Ltd',
	'Beyond Telecommunications Ltd',
	'Bicom Systems EURL',
	'Bink Broadband Ltd',
	'Bink Networks Ltd',
	'bOnline Ltd.',
	'Boxx Communications Ltd',
	'Britannic Technologies Ltd',
	'BT',
	'BT Global Services Ltd',
	'BT Lancashire Services Limited',
	'BT OnePhone Limited',
	'BT Wholesale',
	'Budget Numbers Limited',
	'Business Broadcast Communications Limited',
	'Business Telecom Limited',
	'Buzz Networks Limited',
	'C2C Limited',
	'Caladan Communications Limited',
	'Call Plan Solutions Ltd',
	'CALL2CALL LIMITED',
	'CALLABLE LIMITED',
	'CAPITA SHARED SERVICES LIMITED',
	'Case Communications Limited',
	'Ccpro Solutions Limited',
	'Central Technology Limited',
	'CFL Communications Ltd',
	'Challenger Mobile Communications Ltd',
	'Chalvington Communications Ltd',
	'Chess Limited',
	'CINOS LIMITED',
	'CIRCLES MVNE International B.V.',
	'Cirrus Response Limited',
	'Citrus Telecommunications Ltd',
	'City Numbers Ltd',
	'Citytalk Communications Ltd',
	'Clearstream technology Ltd',
	'Cloud Telecom Ltd',
	'Cloud9 Telephony Limited',
	'Cloudcall Limited',
	'Collabortive Portfolio LTD',
	'Colt Technology Services',
	'Commi Holdings Limited',
	'Comms Uk Limited',
	'Commsworld Limited',
	'Communications Networking Services (UK)',
	'Community Fibre Limited',
	'Comtec Enterprises Limited',
	'Concert Networks Ltd',
	'Connaught Communication Systems Limited',
	'Connect Telecom UK Limited',
	'Connexin Limited',
	'Content Guru Limited',
	'Continuity Assured Limited',
	'Converged Communication Solutions Ltd',
	'Core Communication Services Limited',
	'Core Telecom Limited',
	'Cotswold Community Networks Limited',
	'Crown Telecom Solutions Ltd',
	'Cygnet Total Communications Limited',
	'Daisy Communications Ltd',
	'Damovo UK Limited',
	'Datasharp UK Ltd',
	'DCS Voice & Vision Ltd',
	'Dial 9 Communications Limited',
	'DID Universe LLC',
	'DIDWW Ireland Limited',
	'Digiquip Group Limited',
	'Digital IP Limited',
	'Digital Mail Limited',
	'Digital Select Limited',
	'Digital Space Group Limited',
	'Digitech Solutions Global Limited',
	'DMV Communications Limited',
	'Double Edge Professional Services Ltd',
	'DRD Communications Limited',
	'DuoCall Communications Ltd',
	'Dynamic Mobile Billing Limited',
	'Easynet Network Services Limited',
	'Edge Technical Resources Ltd',
	'Edge Telecommunications Limited',
	'EE Limited ( TM)',
	'EE Limited (Orange)',
	'Efar Limited',
	'EG TECHNOLOGIES LIMITED',
	'Eircom (UK) Limited',
	'Eircom NI Ltd',
	'Elite Limited',
	'Entanet International Ltd',
	'Entigy Ltd',
	'Entropie Ltd',
	'Epsilon Telecommunications Limited',
	'Equate Business Solutions Limited',
	'ESAT Telecommunications (UK) Ltd',
	'Essensys (UK) Limited',
	'ETC Telecom Limited',
	'ETS Communications Ltd',
	'EVE CONNECT LTD',
	'Exa Infrastructure Services UK Limited',
	'Exa Infrastructure UK Limited',
	'Executel Ltd',
	'Exponential-e Limited',
	'Firstcom Europe Limited',
	'FleXtel Limited',
	'Floren Limited',
	'Fluidone Limited',
	'Fram Broadband Ltd',
	'Freeclix Ltd',
	'Fujitsu Services Limited',
	'Fuse 2 Communications Ltd',
	'Gamma Telecom Holdings Limited',
	'GCI Network Solutions Limited',
	'Gencom Technologies Ltd',
	'GlemNet Ltd',
	'Glide Business Limited',
	'Glide Student and Residential Limited',
	'Global Electroteks Ltd',
	'Global Nomi Telecomunicacoes E Servicos LDA',
	'Global Reach Networks Limited',
	'Gofibre Holdings Limited',
	'Gold Telecom Limited',
	'GPC Computer Software Ltd',
	'Greystone Telecom Limited',
	'Group 3 Technology Limited',
	'GTT-EMEA LTD',
	'Guernsey Airtel Limited',
	'Halo Communications Limited',
	'Hanhaa Limited',
	'HB Telecom (UK) Ltd',
	'Hello Telecom (UK) Limited',
	'Hosted IP Communications (Europe) Limited',
	'HSL Messaging Limited',
	'HTL Telecom Limited',
	'Hutchison 3G UK Ltd',
	'Hyperoptic Ltd',
	'I.T Communications Limited',
	'ICC Networks Ltd',
	'Icron Network Limited',
	'ICUK Computing Services Limited',
	'iData Com Ltd',
	'IDE Group Voice Limited',
	'IDT Global Limited',
	'iHub 2 Limited',
	'IM Software Ltd',
	'IMS Technology Services Limited',
	'In2com Ltd',
	'Inet Telecoms Ltd (Voipfone)',
	'INFERNO COMMUNICATIONS LTD',
	'Infinity Tracking Ltd',
	'Initial Technologies Ltd',
	'Innov@te Ltd',
	'Integrated Business Telecommunications Ltd',
	'Integrated Digital Services Ltd',
	'INTERCITY TECHNOLOGY LIMITED',
	'Internet Central Limited',
	'Internet Connections Limited',
	'Internetty Ltd',
	'Internexus Networks Limited',
	'Interoute Managed Services UK Limited',
	'Interoute Vtesse Limited',
	'InTouch Communication Services Limited',
	'Invade International Ltd',
	'Invoco Ltd',
	'Invosys Limited',
	'Iomart Managed Services Limited',
	'IOVOX Limited',
	'IP Integration Limited',
	'IP River Ltd',
	'IP Voice Networks Ltd',
	'IP Wholesale Limited',
	'IPV6 Limited',
	'IPX Telecom Limited',
	'Jersey Airtel Limited',
	'JT (Guernsey) Limited',
	'JT (Jersey) Limited',
	'Jtec UK Limited',
	'Jurassic Fibre Limited',
	'Kalnet4U Ltd',
	'KCOM Group Ltd',
	'KDDI Europe Ltd',
	'Kenton Research Limited',
	'KERV EXPERIENCE LIMITED',
	'Lancashire County Council',
	'Lancaster University Network Services Ltd',
	'Lanonyx Telecom Limited',
	'Lansdowne Telecom Limited',
	'LANtec Services Ltd',
	'Lean Wood Communications Limited',
	'LEBARA MOBILE LIMITED',
	'Limpio Office Solutions Limited',
	'Linear Telecoms Limited',
	'Link Connect Services Ltd',
	'Liquid 11 Limited',
	'Localphone Limited',
	'Logicalis UK Limited',
	'London Central Communications Ltd',
	'London Web Limited',
	'Loop Scorpio Ltd',
	'Lumen Technologies UK Limited',
	'Lyca Home Limited',
	'Lycamobile (UK) Limited',
	'Lycatel Services Ltd',
	'M247 Ltd',
	'M247 UK LIMITED',
	'M3st Limited',
	'Magdalene Limited',
	'Magrathea Telecommunications Limited',
	'Mainstream Digital Ltd',
	'Maintel Voice & Data Limited',
	'Malvern Ventures Limited',
	'MANX TELECOM TRADING LIMITED',
	'Marathon Telecom Limited',
	'Mars Communications Limited',
	'Mason Infotech Ltd',
	'Mass Response Service GmbH',
	'Matrix Platinum Limited',
	'Media Hawk Ltd',
	'Media Telecom Ltd',
	'Merlin Telecommunications Limited',
	'Met Technologies Limited',
	'Mi Telecom Limited',
	'Microtalk Europe Limited',
	'Microtalk Wholesale Limited',
	'Millgate Connect Limited',
	'Minotaur Telecom Limited',
	'Mintaka Limited',
	'Mission Labs Limited',
	'MLL Telecom Ltd',
	'Mnet Internet',
	'Morecom Limited',
	'Motion Communications T/A Catalyst AMC Ltd',
	'Nationwide Telephone Assistance Ltd',
	'Nebula Cloud Limited',
	'Net Defence Limited',
	'Netomnia Limited',
	'Network Business Call Limited',
	'Net-Work Internet Ltd',
	'Network Rail Infrastructure Limited',
	'Networks Direct plc',
	'Neutrino Networks Limited',
	'New Star Networks Ltd',
	'Newtel Limited',
	'Nexbridge Communications Limited',
	'Nextec UK Limited',
	'NextGenAccess Limited',
	'Nexus Telecommunications Limited',
	'NFON UK Ltd',
	'NGN Communications Ltd',
	'Nirenet Limited',
	'Noble Tel',
	'Node4 Ltd',
	'Nodemax Limited',
	'Nova Telecom Ltd',
	'NT Independent Networks Limited',
	'Number Services Ltd.',
	'Number Solutions Ltd',
	'Numbergroup Utilities Ltd',
	'Numbers Plus Ltd',
	'Numbers Telecom Limited',
	'Nuso Cloud UK Limited',
	'NYnet Limited',
	'Odigo',
	'Odyssey Systems Ltd',
	'OGI NETWORKS LIMITED',
	'One Network Limited',
	'Online Assistance Limited',
	'Onvoy Communications Ltd.',
	'Open Telecom Limited',
	'Opex Hosting Limited',
	'Optimity Limited',
	'Opus Telecom Ltd',
	'Orange Business Holdings UK Limited',
	'Orbital Net Limited',
	'Orbtalk Limited',
	'Orca Telecom Ltd',
	'OVH Limited',
	'Pageone Communications Limited',
	'PAYMENT WORLD LTD',
	'Peace Telecom Ltd',
	'Peach Communications Limited',
	'Pebbletree Ltd',
	'PEERLESS NETWORK UK LIMITED',
	'Performance Telecom Limited',
	'Persimmon Homes Limited',
	'Phone Buddy Limited',
	'Pinnacle Telecoms (Wales) Limited',
	'Pipex Communications PLC',
	'Planet Numbers Ltd',
	'Pontano Limited',
	'PORT 5060 LTD',
	'Portal Voice & Data Ltd',
	'Positive ICT Limited',
	'Premier Voicemail Ltd',
	'Promotions4All Ltd',
	'Pulsant (Scotland) Limited',
	'Pure-IP Limited',
	'Quickline Communications Limited',
	'Reach Europe Ltd',
	'Real Telekom Ltd',
	'Realisys Limited',
	'Reality Network Services Limited',
	'Red Matter Limited',
	'Redcentric Solutions Limited',
	'Redwood Technologies Ltd',
	'Relax Telecom Limited',
	'Resilient PLC',
	'Rojo Trading Limited',
	'RRD Communications Ltd T/A ICA',
	'Ryland Communications Ltd',
	'Sala Trading Ltd',
	'Sark Telecom B.V.',
	'SCD Group Limited',
	'Scotnet.Co.UK Ltd.',
	'Sears Communications Ltd',
	'Sensibill Limited',
	'Sentia Global Ltd',
	'Served Up Limited',
	'SERVERHOUSE LIMITED',
	'Service Direct Newco Limited',
	'Shine Networks Limited',
	'ShoreTel UK Limited',
	'Sigma Voice Solutions Ltd',
	'Simple Call Limited',
	'Simwood eSMS Limited',
	'SiPalto Ltd',
	'Sipcentric Ltd',
	'Six Degrees Technology Group Limited',
	'Sky UK Limited',
	'SKYLINE NETWORKS & CONSULTANCY LTD',
	'SMSCGLOBAL LTD',
	'SoldierNET Limited',
	'Solutios Limited',
	'SONA BUSINESS PVT. LTD.',
	'Sound Advertising Ltd',
	'South Tyneside Council',
	'Spacetel UK Ltd',
	'Spark Technology Services Limited',
	'Spectrum Fibre Limited',
	'Spitfire Network Services Limited',
	'Sports Tel Ltd',
	'Square 1 Communications Limited',
	'Square Systems Limited',
	'Stour Marine Limited',
	'Stream Networks Ltd',
	'Structured Communications Limited',
	'Subtopia Limited',
	'Supatel Limited',
	'Supported Business Limited',
	'Sure (Guernsey) Limited',
	'Sure (Isle of Man) Limited',
	'Sure (Jersey) Limited',
	'Suretec Systems Ltd',
	'Sweet Telecom Ltd',
	'Swiftel Limited',
	'Swiftnet Ltd',
	'SWIFTsoft Computer Systems (NI) Ltd',
	'Switch Communications',
	'Syntec Limited',
	'SYNTURA GROUP LIMITED',
	'Syscomm Limited',
	'Sysconfig Ltd',
	'T4COM LTD',
	'Tabsoft Limited',
	'Talk Numbers Ltd',
	'Talk Straight Ltd',
	'Talk.to FZC',
	'Talking Technology Limited',
	'TalkTalk Communications Limited',
	'Talktalk Technology Limited',
	'Tango Networks UK Ltd',
	'TAP GATEWAY LTD',
	'Tata Communications (UK) Limited',
	'Telappliant Limited',
	'Telconline Inc',
	'Telecom 10 Ltd',
	'Telecom2 Limited',
	'TelecomIQ Limited',
	'Telecoms Consortium Ltd',
	'Telecoms World Direct Limited',
	'Telefónica Ireland Limited',
	'TELEFÓNICA TECH NORTHERN IRELAND LIMITED',
	'Telefonica UK Limited',
	'Telemix Limited',
	'Telephone Box Limited',
	'Telesoft Technologies Limited',
	'Telet Research (NI) Limited',
	'TeleWare Group Limited',
	'TelNG Limited',
	'TELNYX UK LIMITED',
	'Telstra UK Limited',
	'TelXL Limited',
	'Tesco Mobile',
	'TESLA LOGIC LTD',
	'TGL Services (UK) Ltd',
	'Thales Transport and Security Limited',
	'The Carphone Warehouse Limited',
	'The Excell Group Limited',
	'The Link Stores Limited',
	'The Midcounties Co-operative Limited',
	'The Networking People (NorthWest) Ltd',
	'The Utility Factory Limited',
	'Time Communication Solutions Ltd',
	'Timico Partner Services Limited',
	'Tiscali UK Limited',
	'Tismi BV',
	'TM Solutions Ltd',
	'Toople.com Limited',
	'Town & Country Communications LLP',
	'TP GLOBAL OPERATIONS LIMITED',
	'Transaction Network Services (UK) Limited',
	'Transglobal UK Limited',
	'Trilogy Networks Limited',
	'Trilogy Telecom Ltd',
	'Trooli Ltd',
	'Truespeed Communications Ltd',
	'T-Systems Limited',
	'TTNC Limited',
	'Turquoise Mobile Limited',
	'Tuxtel Ltd',
	'Twang.net Ltd',
	'Twilio Ireland Limited',
	'UBT (EU) Ltd',
	'UCRESELLER LIMITED',
	'UK BANDWIDTH LIMITED',
	'UK BROADBAND LIMITED',
	'UK Number Store Limited',
	'UK Wholesale Direct Limited',
	'Unisys Limited',
	'Unite Communications Limited',
	'Uni-tel Business Communications Ltd',
	'Univoice Limited',
	'Uniworld Bureau Services Limited',
	'uno Communications Ltd.',
	'Updata Infrastructure (UK) Limited',
	'Urbancoms Ltd',
	'USIC INTERNET SERVICES LIMITED',
	'USIC Ltd',
	'Utilities UK Ltd',
	'V Networks Ltd',
	'Vectone Mobile (Denmark) Limited',
	'Vectone Mobile Limited',
	'Velocity1 Limited',
	'Venture Telecom Limited',
	'Venus Business Communications Limited',
	'Verizon UK Limited',
	'Video Networks Limited',
	'Virgin Media Business Limited',
	'Virgin Media Limited',
	'Virgin Mobile',
	'Virocom Limited',
	'Virtual1 Limited',
	'Visional Media Limited',
	'Vodafone Limited',
	'Vodafone Ltd (C&W)',
	'Vodat International Ltd',
	'Voice Simplified Limited',
	'Voiceflex Limited',
	'VoiceHost Limited',
	'Voicetec Systems Ltd',
	'VoIP-Un Limited',
	'Vonage Business Limited',
	'Vonage Limited',
	'Voxbone SA',
	'VOXYONDER NETWORK SERVICES UK LTD',
	'VTSL Ltd',
	'VYSIION LIMITED',
	'Wanstor Ltd',
	'WAVECREST NETWORKS LIMITED',
	'Wavenet UK Ltd',
	'WELLTEL (UK) LIMITED',
	'WIDEFM LIMITED',
	'Wifinity Limited',
	'WightFibre Limited',
	'Wildcard UK Limited',
	'WIRELESS LOGIC LIMITED',
	'Wireless Telecommunications Limited',
	'Wizaner Limited',
	'Worthmanor Limted T/A Shell Wholesale',
	'Xifos Limited',
	'XLN Telecom Ltd',
	'X-on Health Limited',
	'Xoom Ltd',
	'XoverX Ltd',
	'YayYay Limited',
	'YEMOT HAMOSHIACH UK LTD',
	'York Data Services Limited',
	'Yorkshire Telecommunications Ltd',
	'Zapappi Ltd',
	'Zen Internet Limited',
	'Zestel Limited',
	'Ziron Limited',
	'Zsquare Global Solutions Ltd'
]
